import { Loading } from 'element-ui'

let loadingInstance
let requestCount = 0 // Track concurrent requests

export const showLoading = () => {
    requestCount++

    // Only show loading indicator for the first request
    if (requestCount === 1 && !loadingInstance) {
        loadingInstance = Loading.service({
            lock: true,
            text: 'Hệ thống đang tải dữ liệu ...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
}

export const hideLoading = () => {
    requestCount--

    // Only hide loading when all requests are complete
    if (requestCount <= 0) {
        requestCount = 0 // Reset to prevent negative values
        if (loadingInstance) {
            loadingInstance.close()
            loadingInstance = null
        }
    }
}
